// ordered list of object and name substitutions for the headers of the CSV. This is
// so users aren't confused by the columns being out of order or by them being named
// slightly differently than the table displays. It's a map of the name coming from
// the query service to the translation string, with mouseover if applicable
export const ListHeaderMap = [
  {data:"from",trans:"Screens.Calls.List.From"},
  {data:"dialNumber",trans:"Screens.Calls.List.DialNumber",title:"dialString",titleTrans:"Screens.Calls.List.DialNumberMouseover"},
  {data:"conferenceId",trans:"Screens.Calls.List.ConferenceId"},
  {data:"startTime",trans:"Screens.Calls.List.StartTime"},
  {data:"duration",trans:"Screens.Calls.List.Duration"},
  {data:"endReason",trans:"Screens.Calls.List.EndReason"},
  {data:"agent",trans:"Screens.Calls.List.Agent"},
  {data:"deploymentType",trans:"Screens.Calls.List.Deployment"},
  {data:"region",trans:"Screens.Calls.List.Region"},
  {data:"protocol",trans:"Screens.Calls.List.Protocol"}
];

const ignoredDataFields = ["bookmark","deployment"];

// flatten a list of objects to a CSV. This currently assumes we only want to 
// output keyed objects, so any list within the object will be printed directly
// to that keyed cell
export function convertToCsv(objectList, translate) {
  if (!Array.isArray(objectList) || objectList.length < 1) {
    console.log("No data or empty dataset in CSV conversion request");
    return "";
  }

  // get all the possible headers to flatten this csv
  let headerPaths = getHeaderList(objectList);
  let headerTitles;
  [headerPaths,headerTitles] = doCSVSort(headerPaths, translate);

  let CSV = [];
  CSV.push(headerTitles.join(','));

  objectList.forEach((element) => {
    let line = [];
    headerPaths.forEach((path) => {
      line.push(getDatum(element,path,0));
    });
    CSV.push(line.join(','));
  });

  return CSV.join('\n');
}

function doCSVSort(headerPaths,translate) {
  let newPaths = [];
  let titles = [];
  let parsed = [];
  ListHeaderMap.forEach(item => {
    // might be a bug here since we moved from a multidimensional array to flat array ... if
    // we go back to the data having layers, check here first.
    newPaths.push([item.data]);
    titles.push(translate(item.trans));
    parsed.push(item.data);
  });
  headerPaths.forEach(path => {
    let title = path.join('.');
    title.replace(',',';');
    if (!parsed.includes(title) && !ignoredDataFields.includes(title)) {
      newPaths.push(path);
      titles.push(title);
    }
  });
  return [newPaths,titles];
}

function getDatum(element,path,pathIdx) {
  if (pathIdx === path.length-1) {
    if (!element || !element.hasOwnProperty(path[pathIdx])) {
      return "";
    }
    let e = element[path[pathIdx]];
    if (!e) {
      e = "";
    }
    return e.toString().replace(/,/g, ' ');
  }

  if (element.hasOwnProperty(path[pathIdx])) {
    return getDatum(element[path[pathIdx]],path,pathIdx+1);
  }

  return "";
}

// Get the headers as a list of lists. This should return a list that contains a list "path"
// to get to every object in the list. Not all objects will have all header paths, but we
// need the total so we can make CSV headers
function getHeaderList(list) {
  let headerMap = {};

  list.forEach((element) => {
    getHeaderMap(element, headerMap);
  });

  return flattenHeaderMap(headerMap, []);
}

// helper for getHeaderList: makes a map of all keys in all objects so if we have an object
// with an element at obj.mediaStart.VTC.protocol, this object will have obj.mediaStart.VTC.protocol
// = true. This is to consolidate all keys into one object that we can then flatten to lists.
function getHeaderMap(element, headerMap) {
  if (typeof element === 'object' && element !== null) {
    Object.keys(element).forEach((key) => {
      if (typeof element[key] === 'object' && element[key] !== null) {
        headerMap[key] = {};
        getHeaderMap(element[key], headerMap[key]);
      } else {
        headerMap[key] = true;
      }
    });
  }
}

// helper for getHeaderList: Takes a map of all keys in all objects and returns a list of lists
// where those keys are mapped to a list of keys for how each piece of data is found. For example,
// if the headermap has map.mediaStart.VTC.protocol=true, then this will have a list element of
// list[idx] = [mediaStart,VTC,protocol]
function flattenHeaderMap(headerMap, path) {
  let paths = [];
  Object.keys(headerMap).forEach((key) => {
    let myPath = [...path,key];
    if (typeof headerMap[key] === 'object') {
      paths.push(...flattenHeaderMap(headerMap[key],myPath));
    } else {
      paths.push(myPath);
    }
  });
  return paths;
}

export function downloadFile(data,name, mimeType) {
  const a = document.createElement("a");
  mimeType = mimeType || "application/octet-stream";

  if (navigator.msSaveBlob) {
    // IE10
    navigator.msSaveBlob(
      new Blob([data], {
        type: mimeType
      }),
      name
    );
  } else if (URL && "download" in a) {
    //html5 A[download]
    a.href = URL.createObjectURL(
      new Blob([data], {
        type: mimeType
      })
    );
    a.setAttribute("download", name);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    window.location.href =
      "data:application/octet-stream," + encodeURIComponent(data); // only this mime type is supported
  }
}

